import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../service/auth.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {firstValueFrom} from "rxjs";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  form!: FormGroup;

  constructor(
    private _authService: AuthService,
    private spinner: NgxSpinnerService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.form = new FormGroup({
      username: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    })
  }

  async onClickSignIn() {
    if (this.form.invalid) {
      return;
    }
    await this.spinner.show();

    const loginAction$ = this._authService.doLogin(this.form.value);
    const doLogin = await firstValueFrom(loginAction$);
    if (doLogin?.result) {
      await this.spinner.hide();
    }

  }

}
